import { DocumentationArticle } from '../components/DocumentationArticle';

export const ConnectGoogle = () => {
  return (
    <DocumentationArticle
      title="How to Connect Google Reviews to EchoRatings"
      description="Connect your Google Business Profile so EchoRatings can collect reviews and power automations."
      timeToComplete="2-3 minutes"
      requirements={['Access to your Google Business Profile']}
      sections={[
        {
          title: 'Step 1: Open Integrations in EchoRatings',
          content: (
            <ol className="list-decimal list-inside space-y-2">
              <li>Log in to your EchoRatings account.</li>
              <li>
                From the main dashboard, go to <strong>Settings</strong>.
              </li>
              <li>
                Select <strong>Integrations</strong>.
              </li>
            </ol>
          ),
        },
        {
          title: 'Step 2: Choose Google Reviews',
          content: (
            <ol className="list-decimal list-inside space-y-2">
              <li>
                Click <strong>Connect</strong> next to{' '}
                <strong>Google Reviews</strong>
              </li>
              <li>You'll be redirected to Google to sign in</li>
            </ol>
          ),
        },
        {
          title: 'Step 3: Sign In to Google',
          content: (
            <>
              <ol className="list-decimal list-inside space-y-2 mb-4">
                <li>
                  Sign in using the Google account that manages your Google
                  Business Profile
                </li>
                <li>Review the permissions request</li>
                <li>
                  Click <strong>Allow</strong>
                </li>
              </ol>
              <p className="bg-base-antiFlash p-4 rounded-lg">
                EchoRatings needs permission to read reviews and business profile
                data. We do not post on your behalf without your action.
              </p>
            </>
          ),
        },
        {
          title: 'Step 4: Select Your Business Profile',
          content: (
            <>
              <ol className="list-decimal list-inside space-y-2 mb-4">
                <li>
                  If you manage more than one location, select the correct business
                </li>
                <li>Confirm the selection</li>
              </ol>
              <p>Once connected, you'll be redirected back to EchoRatings.</p>
            </>
          ),
        },
        {
          title: 'Step 5: Confirm the Connection',
          content: (
            <>
              <ol className="list-decimal list-inside space-y-2 mb-4">
                <li>
                  Return to <strong>Settings → Integrations</strong>
                </li>
                <li>
                  Google Reviews should now show as <strong>Connected</strong>
                </li>
              </ol>
              <p>New reviews will begin syncing automatically.</p>
            </>
          ),
        },
        {
          title: 'Common Issues',
          content: (
            <>
              <div className="mb-4">
                <h4 className="font-semibold text-base-raisinBlack mb-2">
                  I don't see my business listed
                </h4>
                <ul className="list-disc list-inside space-y-1">
                  <li>
                    Make sure you're logged into the Google account that owns or
                    manages the profile
                  </li>
                  <li>
                    Confirm the business is verified in Google Business Profile
                  </li>
                </ul>
              </div>
              <div>
                <h4 className="font-semibold text-base-raisinBlack mb-2">
                  Connection shows as failed
                </h4>
                <ul className="list-disc list-inside space-y-1">
                  <li>Try reconnecting and approving permissions again</li>
                  <li>Check that pop-ups are not blocked in your browser</li>
                </ul>
              </div>
            </>
          ),
        },
        {
          title: 'What Happens Next',
          content: (
            <ul className="list-disc list-inside space-y-1">
              <li>Existing reviews will sync into EchoRatings</li>
              <li>New reviews will appear as they are posted</li>
              <li>You can now enable review automations</li>
            </ul>
          ),
        },
      ]}
    />
  );
};
